// istanbul ignore file - this file is not covered by tests as it is not to be released post alpha testing
import { useQueryParams } from '@calendly/hooks';
import { BareButton } from '@calendly/ui/components/bare-button';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { FlexLayout } from '@calendly/ui/components/flex-layout';
import { BodyText } from '@calendly/ui/components/typography';
import { FC } from 'react';
import { useDispatch } from 'react-redux';
import { setGetParams } from 'actions/core/navigation';
import { setForceSSEDisconnect, useForceSSEDisconnect } from '../sse_polling_state';
import { SSEConnectionBadge } from '../SSEConnectionBadge/SSEConnectionBadge';
const menuTriggerCss = "m1d7odnf";
const layoutAlignCenterCss = "l1d71rh6";
const panelCss = "pxv0j7o";
const sectionCss = "sb0mahg";
const sectionLabelCss = "sm87rog";
const toggleButtonCss = "tawi5ns";
const menuSpanCss = "m19dxgax";
export interface MeetingsDebugMenuProps {
  /**
   * When the meetings page is in "live" (realtime) mode, this is the SSE connection state.
   * When not in live mode or SSE is not running, pass undefined.
   */
  connectionState?: string | null;
}

/**
 * Pre-alpha testing menu for the meetings page: connection state, force-disconnect toggle,
 * and live=? query param toggle. Only render when the realtime feature flag is on.
 * See MeetingsDebugMenu/README.md.
 */
export const MeetingsDebugMenu: FC<MeetingsDebugMenuProps> = ({
  connectionState
}) => {
  const dispatch = useDispatch();
  const queryParams = useQueryParams();
  const isLive = queryParams?.live !== '0';
  const forceSSEDisconnect = useForceSSEDisconnect();
  const [toggle, Dropdown, isOpen] = useDropdown();
  const handleToggleLive = () => {
    dispatch(setGetParams({
      live: isLive ? '0' : null
    }) as any);
  };
  const handleToggleForceDisconnect = () => {
    setForceSSEDisconnect(!forceSSEDisconnect);
  };
  const effectiveConnectionState = forceSSEDisconnect ? 'error' : connectionState ?? null;
  return <span className={menuSpanCss} data-testid="meetings-debug-menu">
      <BareButton type="button" onClick={toggle} className={menuTriggerCss} aria-expanded={isOpen} aria-haspopup="true">
        Pre-alpha testing
      </BareButton>
      <Dropdown>
        <div className={panelCss}>
          <BodyText size="small" color="muted">
            For testing only. This UI will not appear in production.
          </BodyText>

          <div className={sectionCss}>
            <span className={sectionLabelCss}>Live page</span>
            <BareButton type="button" onClick={handleToggleLive} className={toggleButtonCss} data-testid="meetings-debug-menu-toggle-live">
              {isLive ? 'On — click to turn off' : 'Off (?live=0) — click to turn on'}
            </BareButton>
          </div>

          <div className={sectionCss}>
            <span className={sectionLabelCss}>SSE connection</span>
            {connectionState != null || isLive ? <FlexLayout className={layoutAlignCenterCss} gap={4} wrap>
                <SSEConnectionBadge connectionState={effectiveConnectionState} isVisible />
                <BareButton type="button" onClick={handleToggleForceDisconnect} className={toggleButtonCss} data-testid="meetings-debug-menu-toggle-sse">
                  {forceSSEDisconnect ? 'Reconnect (test)' : 'Simulate disconnect (test)'}
                </BareButton>
              </FlexLayout> : <BodyText size="small" color="muted">
                Enable live page to see SSE state.
              </BodyText>}
          </div>
        </div>
      </Dropdown>
    </span>;
};

require("./MeetingsDebugMenu.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./MeetingsDebugMenu.tsx");